/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View } from '@components/atoms'
import { NodeModel } from '@minoru/react-dnd-treeview'
import { mono } from '@components/systems/backoffice/backoffice.tokens'

type Props = {
	node: NodeModel
	depth: number
}

/** 드롭 자리표시 — 1px ink 선 */
export const Placeholder: React.FC<Props> = props => {
	return (
		<View css={style} style={{ left: props.depth * 24 }} data-testid="placeholder"></View>
	)
}

const style = css({
	backgroundColor: mono.ink,
	width: '100%',
	height: 1,
	position: 'absolute',
	right: 0,
	transform: 'translateY(-50%)',
	top: 0,
})
